import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid, Link, units } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';

import { ReportUserBtn } from './ReportUserBtn';

const useStyles = makeStyles()(() => ({
  root: {
    padding: units.rem(1),
  },
  icon: {
    fontSize: units.rem(0.75),
  },
}));

interface Props {
  reportedUserID: number | string;
}

const UserCardReportBtn: React.FC<Props> = ({ reportedUserID }) => {
  const { classes } = useStyles();
  const { T, urlResolver } = useIntl();

  return (
    <div className={classes.root}>
      <ReportUserBtn
        reportedUserID={+reportedUserID}
        buttonElement={({ onClick }) => (
          <React.Fragment>
            <Grid container spacing={1} direction="column">
              <Grid item>
                <Link to="" kind="mint-underline" onClick={onClick}>
                  {T('Report this user')}
                </Link>
              </Grid>
              <Grid item>
                <Link to={urlResolver.getContactUrl()} kind="mint-underline">
                  {T('contact_support.1_link')}
                </Link>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
      />
    </div>
  );
};

export { UserCardReportBtn };
